<template>
  <el-dialog width="42%" class="open-question-invitation" :visible.sync="show">
    <template #title>
      <div class="title-container">
        <div class="title">{{ $t(`${i18nPrefix}.title`) }}</div>
        <div class="tip">{{ $t(`${i18nPrefix}.message.inviteTip.0`) }}</div>
        <div class="tip">{{ $t(`${i18nPrefix}.message.inviteTip.1`) }}</div>
        <div class="tip">{{ $t(`${i18nPrefix}.message.knockoutTip`) }}</div>
      </div>
    </template>
    <div class="question-container">
      <QuestionListEditor
        v-model="questionList"
        append-dialog-to-body
        :group-list="groupList"
        :disabled-question-type="disabledQuestionType"
        :size-limit="questionSizeLimit"
        :disable-question-group="disableQuestionGroup"
      />
    </div>
    <template #footer>
      <div class="bottom-btn-group adapt-wrapper">
        <el-button class="cancel-btn grey-btn" @click="handleCancel">{{ $t('common.btn.cancel') }}</el-button>
        <el-button class="save-btn blue-btn" @click="handleInvite">{{ $t(`${i18nPrefix}.btn.invite`) }}</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import QuestionListEditor from '@/components/openQuestion/questionListEditor.vue'
import { mapActions } from 'vuex'
import { MAX_NORMAL_QUESTION_ATTACHMENT_TYPE_SIZE_LIMIT, MAX_NORMAL_QUESTION_VIDEO_TYPE_SIZE_LIMIT, QUESTION_TYPE } from '@/constant/openQuestion'
import _ from 'lodash'

export default {
  components: {
    QuestionListEditor
  },
  data () {
    return {
      i18nPrefix: 'admin.application.invitation.openQuestion',
      show: false,
      groupListLoader: null,
      groupList: [],
      questionList: [],
      questionSizeLimit: {
        [QUESTION_TYPE.VIDEO]: MAX_NORMAL_QUESTION_VIDEO_TYPE_SIZE_LIMIT,
        [QUESTION_TYPE.ATTACHMENT]: MAX_NORMAL_QUESTION_ATTACHMENT_TYPE_SIZE_LIMIT
      }
    }
  },
  computed: {
    hasVideoQuestionPermission () {
      return this.hasAnyPermission('PREMIUM_UPLOAD_VIDEO')
    },
    hasAttachmentQuestionPermission () {
      return this.hasAnyPermission('PREMIUM_UPLOAD_PORTFOLIO')
    },
    disableQuestionGroup () {
      return !this.hasAnyPermission('PERM_JOB_QUESTION_TEMPLATE')
    },
    disabledQuestionType () {
      const disabled = [QUESTION_TYPE.SINGLE_SELECT, QUESTION_TYPE.MULTIPLE_SELECT]
      if (!this.hasVideoQuestionPermission) {
        disabled.push(QUESTION_TYPE.VIDEO)
      }
      if (!this.hasAttachmentQuestionPermission) {
        disabled.push(QUESTION_TYPE.ATTACHMENT)
      }
      return disabled
    }
  },
  created () {
    const adapter = window.parent._openQuestionDialogAdapter
    adapter.show = async () => {
      await this.loadGroupList()
      this.show = true
    }
    adapter.close = () => {
      this.show = false
    }
    this.loadGroupList()
  },
  mounted () {
    const rootLayoutEl = this.$parent.$parent.$el
    rootLayoutEl.style.display = 'block'
    rootLayoutEl.style.background = 'none'
    const layoutBodyEl = rootLayoutEl.querySelector('.body')
    layoutBodyEl.style.display = 'block'
    layoutBodyEl.style.width = '100vw'
    layoutBodyEl.style.height = '100vh'
    layoutBodyEl.style.padding = '0'
    rootLayoutEl.querySelector('.header').style.display = 'none'
    rootLayoutEl.querySelector('.footer').style.display = 'none'
  },
  methods: {
    ...mapActions('openQuestion', ['getQuestionTemplateGroupList']),
    async loadGroupList () {
      if (this.disableQuestionGroup) {
        return this.groupList
      }
      this.$eventBus.$emit('showLoading', true)
      if (!this.groupListLoader) {
        this.groupListLoader = this.getQuestionTemplateGroupList({ active_only: 1 }).then(resp => {
          this.groupList = resp
        })
      }
      await this.groupListLoader
      this.$eventBus.$emit('showLoading', false)
      return this.groupList
    },
    handleCancel () {
      this.show = false
    },
    handleInvite () {
      if (this.questionList.length < 1) {
        return
      }
      this.$eventBus.$emit('showLoading', true)
      const popupAdapter = window.parent._openQuestionPopupAdapter
      popupAdapter.submit(_.map(this.questionList, question => {
        return {
          id: question.id,
          group_id: question.group_id,
          type: question.type,
          question: question.title,
          duration: question.duration,
          answers: _.map(question.options, option => {
            return {
              ...option,
              value: option.description
            }
          })
        }
      }), () => {
        this.$eventBus.$emit('showLoading', false)
      })
    }
  },
  watch: {
    show () {
      this.$nextTick(() => {
        this.$eventBus.$emit('showLoading', !this.show)
        if (!this.show) {
          this.questionList = []
          const popupAdapter = window.parent._openQuestionPopupAdapter
          popupAdapter.close()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.open-question-invitation {
  .title-container {
    .title {
      margin-bottom: 5px;
      font-size: 24px;
      font-weight: bold;
    }

    .tip {
      margin-top: 5px;
    }
  }

  .bottom-btn-group {
    display: flex;
    margin-top: 20px;

    .el-button {
      padding: 8px 20px;

      &:last-child {
        margin-left: auto;
        margin-right: 0;
      }
    }
  }
}
</style>
